import { Box, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { FC } from 'react'
import { useTutorialQuery } from '~/generated/graphql'
import { pagesPath, staticPath } from '~/lib/$path'
import Link from 'next/link'
import { eventPush } from '~/lib/gtmHelper'
import { SectionCardContainer } from '~/components/common/SectionCardContainer'
import CheckCircleIcon from '@mui/icons-material/Check'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

export const Tutorial: FC = () => {
  const { data } = useTutorialQuery()

  if (!data) return null
  let imageUrl = ''
  let pagePath = ''
  // 表示の優先度が低い順に判定

  // 再連携が必要な場合はnullが返る。nullの場合はスキップ
  if (data.viewer.company?.tutorial.hasInstagramWebsiteLink === false) {
    imageUrl = staticPath.tutorial.lead_wire_png
    pagePath = pagesPath.instagram_website.$url().pathname
  }
  if (!data.viewer.company?.tutorial.hasOffer) {
    imageUrl = staticPath.tutorial.check_applicant_png
    pagePath = pagesPath.campaigns.$url().pathname
  }
  if (!data.viewer.company?.tutorial.hasBeginnerDoneCheck) {
    imageUrl = staticPath.tutorial.attracting_customers_png
    pagePath = pagesPath.beginner.instagram.$url().pathname
  }
  if (!data.viewer.company?.tutorial.hasInstagramConnection) {
    imageUrl = staticPath.tutorial.effect_analysis_png
    pagePath = pagesPath.home.$url().pathname
  }
  if (!data.viewer.company?.tutorial.hasCampaign) {
    imageUrl = staticPath.tutorial.create_campaign_png
    pagePath = pagesPath.campaign_create.$url().pathname
  }
  if (!data.viewer.company?.tutorial.hasTicket) {
    imageUrl = staticPath.tutorial.buy_ticket_png
    pagePath = pagesPath.contract.$url().pathname
  }
  if (!imageUrl || !pagePath) return null
  return (
    <SectionCardContainer
      icon={<CheckCircleIcon sx={{ fontSize: 24, color: 'text.primary' }} />}
      title="次のステップ"
      showAnimation
    >
      <TutorialBanner imageUrl={imageUrl} pagePath={pagePath} />
    </SectionCardContainer>
  )
}

type Props = { imageUrl: string; pagePath: string }
const TutorialBanner: FC<Props> = ({ imageUrl, pagePath }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box sx={{ p: 3 }}>
      <Box
        sx={{
          position: 'relative',
          maxWidth: '1200px',
          mx: 'auto',
          overflow: 'hidden',
          borderRadius: 2,
          boxShadow: '0px 2px 10px -2px rgba(0, 0, 0, 0.08)',
          '&:hover': {
            opacity: 0.8,
            transition: 'opacity 0.2s ease-in-out',
          },
        }}
      >
        <Link href={pagePath} onClick={() => eventPush('click_top_banner', { banner_type: pagePath })}>
          <img
            src={imageUrl}
            alt=""
            style={{
              width: '100%',
              height: 'auto',
              minHeight: isMobile ? 0 : '150px',
              objectFit: 'cover',
              display: 'block',
            }}
          />
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{
              position: 'absolute',
              bottom: isMobile ? 6 : 14,
              right: isMobile ? 6 : 16,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              borderRadius: 2,
              px: isMobile ? 0.5 : 1.25,
              py: isMobile ? 0.5 : 1,
              color: 'white',
            }}
          >
            {!isMobile && (
              <Typography
                variant="labelMJpNormal"
                sx={{
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                詳しく見る
              </Typography>
            )}
            <ArrowForwardIcon sx={{ fontSize: 24 }} />
          </Stack>
        </Link>
      </Box>
    </Box>
  )
}
